import { useState } from 'react';
import { Filters } from './components/FiltersLayout';
import { Map } from './components/Map';
import { Actions } from './components/Actions';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { typeFilters } from './constants';
import { usePageTracking } from 'hooks/usePageTracking';

import './styles.scss';

const giaoThong = typeFilters['giao-thong'].map((filter) => filter.id);
const tienIch = typeFilters['tien-ich'].map((filter) => filter.id);

const LienKetVungPage = () => {
  usePageTracking('neighborhood');
  const [filterList, setFilterList] = useState({
    'tien-ich': ['airport'],
    'giao-thong': giaoThong,
  });
  const [isHighlight, setIsHighlight] = useState(true);
  const [isShowCircle, setIsShowCircle] = useState(false);

  const isDesktop = window.innerWidth > 1024;
  const isTablet = window.innerWidth <= 1024 && window.innerWidth > 480;

  const handleMapResponsive = () => {
    if (isDesktop) {
      return {
        initialScale: 2,
        minScale: 2,
        maxScale: 4,
        wheel: {
          step: 0.03,
        },
        centerOnInit: true,
        disablePadding: true,
        centerZoomedOut: true,
      };
    }

    if (isTablet) {
      return {
        initialScale: 2.4,
        minScale: 2.4,
        maxScale: 8,
        wheel: {
          step: 0.1,
        },
        initialPositionX: -204,
        initialPositionY: -21,
        centerOnInit: false,
        disablePadding: false,
        centerZoomedOut: true,
      };
    }

    return {
      initialScale: 2,
      minScale: 2,
      maxScale: 8,
      wheel: {
        step: 0.1,
      },
      initialPositionX: -715,
      initialPositionY: 7,
      centerOnInit: false,
      disablePadding: false,
      centerZoomedOut: true,
    };
  };

  const handleChangeFilters = (filter, type) => {
    if (!type) throw new Error('Type is required');

    if (!filter) {
      return setFilterList((prev) => ({ ...prev, [type]: [] }));
    }

    if (filterList[type].includes(filter)) {
      return setFilterList((prev) => ({
        ...prev,
        [type]: prev[type].filter((item) => item !== filter),
      }));
    }

    setFilterList((prev) => ({
      ...prev,
      [type]: [...prev[type], filter],
    }));
  };

  const handleShowAllFilters = () => {
    return setFilterList((prev) => ({
      ...prev,
      'giao-thong': giaoThong,
      'tien-ich': tienIch,
    }));
  };

  return (
    <div className="lien-ket-vung-page">
      <Filters
        filterList={filterList}
        onChangeFilters={handleChangeFilters}
        handleShowAllFilters={handleShowAllFilters}
        handleHideAllFilters={() =>
          setFilterList((prev) => ({
            ...prev,
            'tien-ich': [],
          }))
        }
      />
      <div className="lien-ket-vung-content">
        <TransformWrapper {...handleMapResponsive()}>
          <TransformComponent>
            <Map
              filterList={filterList}
              isHighlight={isHighlight}
              isShowCircle={isShowCircle}
            />
          </TransformComponent>
        </TransformWrapper>
      </div>

      {isDesktop && (
        <Actions
          isHighlight={isHighlight}
          onToggleHighlight={() => setIsHighlight((prev) => !prev)}
          isShowCircle={isShowCircle}
          onToggleCircle={() => setIsShowCircle((prev) => !prev)}
        />
      )}
    </div>
  );
};

export default LienKetVungPage;
